// extracted by mini-css-extract-plugin
export default {"table":"Table_table__hWUru","th":"Table_th__EYpoJ","td":"Table_td__XYXWW","tr":"Table_tr__8o8YU","fixedTable":"Table_fixedTable__LfFB6"};